module.exports = __webpack_public_path__ + "img/back_top.c905d863.png";